var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeolocationB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GeoAlt",
    clipPath: "url(#clip0_31_1216)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.1754 22.9087C29.8326 25.6301 28.0133 28.3413 26.1529 30.7756C24.3881 33.0706 22.5011 35.269 20.5 37.3612C18.4989 35.2691 16.6119 33.0707 14.8471 30.7756C12.9868 28.3413 11.1674 25.6301 9.82463 22.9087C8.4665 20.1592 7.6875 17.5839 7.6875 15.375C7.6875 11.9769 9.03738 8.718 11.4402 6.31519C13.843 3.91238 17.1019 2.5625 20.5 2.5625C23.8981 2.5625 27.157 3.91238 29.5598 6.31519C31.9626 8.718 33.3125 11.9769 33.3125 15.375C33.3125 17.5839 32.5309 20.1592 31.1754 22.9087ZM20.5 41C20.5 41 35.875 26.4296 35.875 15.375C35.875 11.2973 34.2551 7.3866 31.3718 4.50323C28.4884 1.61986 24.5777 0 20.5 0C16.4223 0 12.5116 1.61986 9.62823 4.50323C6.74486 7.3866 5.125 11.2973 5.125 15.375C5.125 26.4296 20.5 41 20.5 41Z",
    fill: "#6675FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.5 20.5C19.1408 20.5 17.8372 19.96 16.8761 18.9989C15.915 18.0378 15.375 16.7342 15.375 15.375C15.375 14.0158 15.915 12.7122 16.8761 11.7511C17.8372 10.79 19.1408 10.25 20.5 10.25C21.8592 10.25 23.1628 10.79 24.1239 11.7511C25.085 12.7122 25.625 14.0158 25.625 15.375C25.625 16.7342 25.085 18.0378 24.1239 18.9989C23.1628 19.96 21.8592 20.5 20.5 20.5ZM20.5 23.0625C22.5389 23.0625 24.4942 22.2526 25.9359 20.8109C27.3776 19.3692 28.1875 17.4139 28.1875 15.375C28.1875 13.3361 27.3776 11.3808 25.9359 9.93912C24.4942 8.49743 22.5389 7.6875 20.5 7.6875C18.4611 7.6875 16.5058 8.49743 15.0641 9.93912C13.6224 11.3808 12.8125 13.3361 12.8125 15.375C12.8125 17.4139 13.6224 19.3692 15.0641 20.8109C16.5058 22.2526 18.4611 23.0625 20.5 23.0625Z",
    fill: "#6675FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_1216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeolocationB);
export default __webpack_public_path__ + "static/media/geolocationB.14e0cdcc5c20a30c921324b791cf647a.svg";
export { ForwardRef as ReactComponent };